import { render, staticRenderFns } from "./VesselView.vue?vue&type=template&id=28ecd10b&scoped=true"
import script from "./VesselView.vue?vue&type=script&lang=js"
export * from "./VesselView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecd10b",
  null
  
)

export default component.exports